import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-services.as-carousel").forEach((el) => {
    const container = el.querySelector(".swiper");

    new Swiper(container, {
      modules: [A11y, Navigation],
      speed: 750,
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      simulateTouch: false,
      slidesPerView: 1,
      spaceBetween: 24,
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 36,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 40,
        },
        1440: {
          slidesPerView: 3.2,
          spaceBetween: 40,
        },
      },
    });
  });
});
